const AWS = new function() {
  this.result;
  this.kommunekoder = "420|480|430|440|482|410|450|461|479";

  this.ajax = function (url, callback){
    var xmlhttp;
    var response;
    xmlhttp = new XMLHttpRequest();
    xmlhttp.onreadystatechange = function(){
        if (xmlhttp.readyState == 4 && xmlhttp.status == 200){
            response = xmlhttp.responseText;
        }
    }
    xmlhttp.open("GET", url, false);
    xmlhttp.send();

    return response;
  }

  this.getAddress = function(lat, lng){
    var response = this.ajax("https://dawa.aws.dk/adgangsadresser/reverse?x="+lng+"&y="+lat);
    response = JSON.parse(response);

    return {
      street: response.vejstykke.navn,
      nr: response.husnr,
      postalCode: response.postnummer.nr,
      region: response.region.navn
    };
  };


  this.getCoords = function(ad){
    ad = this.decodeAddress(ad);

    var params = "vejnavn="+encodeURI(ad.street);
    if(ad.nr != undefined){
        params += "&husnr="+ad.nr;
    }

    if(ad.postalCode != undefined){
        params += "&postnr="+ad.postalCode;
    }
    else{
      params += "&kommunekode=461";
    }

    var r = this.ajax("https://dawa.aws.dk/adresser?"+params);
    r = JSON.parse(r);

    if(r == ""){
      return false;
    }

    return r;

  };

  this.getFirstCoords = function(ad) {
    var result = this.getCoords(ad);

    if(result == "") {
      return false;
    }
    return result[0];
  };


  this.awsifyName = function(str){
	  str = str.split("-");

	  for(var s in str){
		  str[s] = str[s].replace(/[^\s]+/g, function(word) {
                      return word.replace(/^./, function(first) {
                        return first.toUpperCase();
                      });
                    });
	  }

	  return str.join("-");

	  /*
      return str = str.replace(/[^\s]+/g, function(word) {
                      return word.replace(/^./, function(first) {
                        return first.toUpperCase();
                      });
                    });*/
  }


  this.decodeAddress = function(address) {
    var result = {};

    if(address.indexOf(",") !== -1) {
      address = address.split(",");
      result.postalCode = address[1].trim();
      address = address[0];
    }

    if(address.hasNumbers()) {
      address = address.split(" ");

  	  if(address.last().length == 4 && address.last().hasNumbers()) {
		    result.postalCode = address.last();
	      address.pop();
  	  }
  	  if(address.last().hasNumbers()) {
		    result.nr = address.last().trim();
	      address.pop();
      }
      result.street = this.awsifyName(address.join(" ").trim());
    }
    else {
      result.street = this.awsifyName(address);
    }

    return result;
  };


  this.getHouseNumbers = function(v, p){
	var a = "&kommunekode=461";
	if(p != undefined){
		a = "&postnr="+p;
	}

	var r = this.ajax("http://dawa.aws.dk/adgangsadresser?vejnavn="+v+a);
	r = JSON.parse(r);

	if(r == ""){
		return false;
	}

	return r;
  };

  this.getFirstHouseNumber = function(v, p){
	var r = this.getHouseNumbers(v);

	if(r == "" || r == false){
		return false;
	}

	return r[0].husnr;
  };


  this.searchForStreetsOnFyn = function(v, fuzzy) {
  	if(fuzzy == undefined){
  		fuzzy = "";
  	}
  	else{
  		fuzzy = "&fuzzy=true";
  	}


  	var r = this.ajax("https://dawa.aws.dk/vejnavne?q="+encodeURIComponent(v)+"*&kommunekode="+this.kommunekoder+fuzzy);

  	r = JSON.parse(r);
  	//console.log(r);
  	if(r == "" || r == false){
  		return false;
  	}

  	var res = [];

  	for(var i in r){
  		for(var p in r[i].postnumre){
  			res.push({street: r[i].navn, code: r[i].postnumre[p].nr, comune: r[i].postnumre[p].navn, href: r[i].postnumre[p].href});
  		}
  	}

  	return res;
  };



  this.lookUpHouseNumbers = function(vn, kk){

	var r = this.ajax("https://dawa.aws.dk/adgangsadresser?vejnavn="+encodeURIComponent(vn)+"&postnr="+kk);

	r = JSON.parse(r);

	if(r == "" || r == false){
		return false;
	}

	var res = [];

	for(var i in r){
		res.push({street: r[i].vejstykke.navn,
					number: r[i].husnr,
					city: r[i].postnummer.navn,
					postalcode: r[i].postnummer.nr,
					latlng: {
						lat: r[i].adgangspunkt.koordinater[1],
						lng: r[i].adgangspunkt.koordinater[0]
					}
				});
	}

	res.sort(function(a, b){
		return parseFloat(a.number) - parseFloat(b.number);
	});

	return res;
  };
};

Object.defineProperty(Array.prototype, "first", {
  enumerable: false,
  value: function(obj) {
      return this[0];
    }
});

Object.defineProperty(Array.prototype, "last", {
  enumerable: false,
  value: function(obj) {
      return this[this.length - 1];
    }
});

Object.defineProperty(String.prototype, "hasNumbers", {
  enumerable: false,
  value: function(){
    return this.match(/\d/i);
  }
});

export default AWS;
